import { Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { LayoutBackground } from '../../components/Layout/LayoutBackground/LayoutBackground.component';
import { Prompt } from '../../components/Prompt/Prompt.component';
import { useHistory } from 'react-router-dom';
import { confirmUpdateUserEmail, verifyUserToken } from '../../services/users/users.service';
import { useParams } from 'react-router-dom';
import { TokenResponse } from './TokenResponse.types';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { useTranslation } from 'react-i18next';

export const EmailActivation: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const [isEmailConfirmationPromptVisible, setIsEmailConfirmationPromptVisible] = useState<boolean>(false);
  const [isLinkExpiredPromptVisible, setIsLinkExpiredPromptVisible] = useState<boolean>(false);
  const [isSuccessPromptVisible, setIsSuccessPromptVisible] = useState<boolean>(false);
  const [isErrorPromptVisible, setIsErrorPromptVisible] = useState<boolean>(false);
  const [isLinkAlreadyUsedPromptVisible, setIsLinkAlreadyUsedPromptVisible] = useState<boolean>(false);

  const { token } = useParams() as { token: string };

  useDocumentTitle('Potwierdź email');

  const handleConfirmUpdateUserEmail = () => {
    if (token) {
      confirmUpdateUserEmail(token).then(
        () => {
          setIsEmailConfirmationPromptVisible(false);
          setIsSuccessPromptVisible(true);
        },
        () => {
          setIsEmailConfirmationPromptVisible(false);
          setIsErrorPromptVisible(true);
        },
      );
    } else setIsErrorPromptVisible(true);
  };

  const handleVerifyToken = () => {
    verifyUserToken(token).then(
      (res: TokenResponse) => {
        switch (res) {
          case TokenResponse.Valid:
            setIsEmailConfirmationPromptVisible(true);
            break;
          case TokenResponse.Expired:
            setIsLinkExpiredPromptVisible(true);
            break;
          case TokenResponse.NotExist:
            setIsLinkAlreadyUsedPromptVisible(true);
            break;
        }
      },
      () => {
        setIsErrorPromptVisible(true);
      },
    );
  };

  useEffect(() => {
    handleVerifyToken();
  }, [token]);

  useEffect(() => {
    if (
      isSuccessPromptVisible ||
      isErrorPromptVisible ||
      isLinkExpiredPromptVisible ||
      isLinkAlreadyUsedPromptVisible
    ) {
      setTimeout(() => {
        history.push('/');
      }, 10000);
    }
  }, [isSuccessPromptVisible, isErrorPromptVisible, isLinkExpiredPromptVisible, isLinkAlreadyUsedPromptVisible]);

  const ConfirmPromptSubText = () => {
    return (
      <Grid item xs={11}>
        <Typography
          variant="body1"
          style={{
            fontWeight: 400,
            fontSize: '15px',
            paddingBottom: '20px',
            lineHeight: 2,
          }}
        >
          Klikając w poniższy przycisk potwierdzasz zmianę adresu e-mail, nowy adres e-mail stanie się nowym loginem do
          aplikacji {t('global:shortNames.system')}.
        </Typography>
      </Grid>
    );
  };

  const SuccessErrorExpiredPromptSubText = () => {
    return (
      <Grid item xs={11}>
        <Typography
          variant="body1"
          style={{
            fontWeight: 400,
            fontSize: '15px',
            paddingBottom: '20px',
            lineHeight: 2,
          }}
        >
          Za chwilę automatycznie zostaniesz przekierowany/na do ekranu logowania. Jeśli przekierowanie nie nastąpi
          automatycznie kliknij w poniższy przycisk.
        </Typography>
      </Grid>
    );
  };

  const logout = () => {
    history.push('/');
  };

  return (
    <>
      <LayoutBackground />
      {isEmailConfirmationPromptVisible && (
        <Prompt
          type="confirm email"
          open={isEmailConfirmationPromptVisible}
          isBold={true}
          size="xs"
          mainText={'Potwierdź zmianę adresu e-mail.'}
          mainActionButtonText={'Potwierdź email'}
          enhancedText={<ConfirmPromptSubText />}
          onConfirm={handleConfirmUpdateUserEmail}
          isRemovedBackdrop={true}
        />
      )}
      {isLinkExpiredPromptVisible && (
        <Prompt
          type="expired link"
          open={isLinkExpiredPromptVisible}
          isBold={true}
          size="xs"
          mainText={'Twój link stracił ważność.'}
          enhancedText={<SuccessErrorExpiredPromptSubText />}
          mainActionButtonText={'Powrót do logowania'}
          onConfirm={logout}
          isRemovedBackdrop={true}
        />
      )}
      {isLinkAlreadyUsedPromptVisible && (
        <Prompt
          type="link already used"
          open={isLinkAlreadyUsedPromptVisible}
          isBold={true}
          size="xs"
          mainText={'Link aktywacyjny został już wykorzystany.'}
          enhancedText={<SuccessErrorExpiredPromptSubText />}
          mainActionButtonText={'Powrót do logowania'}
          onConfirm={logout}
          isRemovedBackdrop={true}
        />
      )}
      {isSuccessPromptVisible && (
        <>
          <Prompt
            type="success"
            open={isSuccessPromptVisible}
            isBold={true}
            size="xs"
            mainText={'Potwierdzenie zmiany adresu e-mail zakończone sukcesem.'}
            enhancedText={<SuccessErrorExpiredPromptSubText />}
            mainActionButtonText={'Powrót do logowania'}
            onConfirm={logout}
            isRemovedBackdrop={true}
          />
        </>
      )}
      {isErrorPromptVisible && (
        <Prompt
          type="error"
          open={isErrorPromptVisible}
          isBold={true}
          size="xs"
          mainText={'Potwierdzenie zmiany adresu e-mail nie powiodło się, spróbuj ponownie później.'}
          enhancedText={<SuccessErrorExpiredPromptSubText />}
          mainActionButtonText={'Powrót do logowania'}
          onConfirm={logout}
          isRemovedBackdrop={true}
        />
      )}
    </>
  );
};
